import { Component, Input, OnInit } from '@angular/core';
import { ICTipoFeedItem } from 'src/app/models/enum';
import { ICFeedItem } from 'src/app/models/ic/ic-feed-item';

@Component({
  selector: 'app-icnav-bar-feed-item-layout',
  templateUrl: './icnav-bar-feed-item-layout.component.html',
  styleUrls: ['./icnav-bar-feed-item-layout.component.scss']
})
export class ICNavBarFeedItemLayoutComponent implements OnInit {

  @Input() item: ICFeedItem;
  tipoFeedItem = ICTipoFeedItem;
  
  constructor() { }

  ngOnInit() {
  }

}
